import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import PublicOrder from "@/pages/PublicOrder";
import Dashboard from "@/pages/Dashboard";
import Orders from "@/pages/Orders";
import Clients from "@/pages/Clients";
import Subscriptions from "@/pages/Subscriptions";
import Complaints from "@/pages/Complaints";
import Geography from "@/pages/Geography";
import Personnel from "@/pages/Personnel";
import Couriers from "@/pages/Couriers";
import Tarifs from "@/pages/Tarifs";
import Expenses from "@/pages/Expenses";
import Notifications from "@/pages/Notifications";
import Reports from "@/pages/Reports";
import CollectionSlots from "@/pages/CollectionSlots";
import Tresorerie from "@/pages/Tresorerie";
import Comptabilite from "@/pages/Comptabilite";
import Fiscalite from "@/pages/Fiscalite";
import Maintenance from "@/pages/Maintenance";
import CourierHome from "@/pages/courier/CourierHome";
import CourierOrder from "@/pages/courier/CourierOrder";
import ForcePasswordChange from "@/pages/ForcePasswordChange";

function RootRedirect() {
  const { user } = useAuth();
  if (user === null) return null;
  if (user === false) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <Navigate to="/change-password" replace />;
  const dest = user.role === "courier" ? "/livreur" : user.role === "logistics_manager" ? "/orders" : "/dashboard";
  return <Navigate to={dest} replace />;
}

const ADMIN = ["super_admin", "logistics_manager"];
const SUPER = ["super_admin"];

const superRoute = (el) => <ProtectedRoute roles={SUPER}>{el}</ProtectedRoute>;

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/commander" element={<PublicOrder />} />
          <Route
            path="/change-password"
            element={
              <ProtectedRoute>
                <ForcePasswordChange />
              </ProtectedRoute>
            }
          />

          <Route
            path="/livreur"
            element={
              <ProtectedRoute roles={["courier"]}>
                <CourierHome />
              </ProtectedRoute>
            }
          />
          <Route
            path="/livreur/commande/:id"
            element={
              <ProtectedRoute roles={["courier"]}>
                <CourierOrder />
              </ProtectedRoute>
            }
          />

          <Route
            element={
              <ProtectedRoute roles={ADMIN}>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/dashboard" element={superRoute(<Dashboard />)} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/clients" element={superRoute(<Clients />)} />
            <Route path="/subscriptions" element={superRoute(<Subscriptions />)} />
            <Route path="/complaints" element={superRoute(<Complaints />)} />
            <Route path="/geography" element={superRoute(<Geography />)} />
            <Route path="/personnel" element={superRoute(<Personnel />)} />
            <Route path="/couriers" element={<Couriers />} />
            <Route path="/tarifs" element={superRoute(<Tarifs />)} />
            <Route path="/expenses" element={superRoute(<Expenses />)} />
            <Route path="/notifications" element={superRoute(<Notifications />)} />
            <Route path="/reports" element={superRoute(<Reports />)} />
            <Route path="/collecte" element={superRoute(<CollectionSlots />)} />
            <Route path="/tresorerie" element={superRoute(<Tresorerie />)} />
            <Route path="/comptabilite" element={superRoute(<Comptabilite />)} />
            <Route path="/fiscalite" element={superRoute(<Fiscalite />)} />
            <Route path="/maintenance" element={superRoute(<Maintenance />)} />
          </Route>

          <Route path="/" element={<RootRedirect />} />
          <Route path="*" element={<RootRedirect />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
